var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSecond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 129,
    viewBox: "0 0 220 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 130.01 92.0729)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 164.425 94.2111)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 22.4746 8.30432)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 32.8262 29.229)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 48.2127 50.9606)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 71.9035 70.4475)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-0.937199 -0.348795 -0.348795 0.937199 99.2127 85.9462)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.373 84.1748C206.225 83.0533 205.682 81.4262 204.327 81.0413L188.949 76.6728C187.403 76.2336 185.997 77.7055 186.506 79.2301L192.215 96.3297C192.724 97.8544 194.733 98.186 195.705 96.906L205.373 84.1748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSecond);
export default __webpack_public_path__ + "static/media/arrowSecond.0f9fb964e027f5f5c99c24e68cb3a3af.svg";
export { ForwardRef as ReactComponent };